import { NgTemplateOutlet } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, output, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SearchCriteria } from "../../pojo/SearchCriteria";
import { Item } from "../../pojo/Item";
import { Proto } from "../../pojo/Proto";
import { SearchCriteriaService } from "../../services/search/search-criteria/search.criteria.service";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25InfoMessageModule } from "../s25-info-message/s25.info.message.module";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25RadioModule } from "../s25-radio/s25.radio.module";
import { S25SimpleCollapseModule } from "../s25-simple-collapse/s25.simple.collapse.module";
import { S25StandardScheduleModule } from "../s25-standard-schedule/s25.standard.schedule.module";
import { S25TimepickerModule } from "../s25-timepicker/s25.timepicker.module";
import { S25QLConst } from "./s25ql.const";
import { AdvancedStep } from "./s25ql.search.advanced.criteria.component";
import { S25Util } from "../../util/s25-util";
import { AdvancedSearchUtil } from "../advanced-search/advanced-search-util";
import { S25Const } from "../../util/s25-const";
import { S25qlSearchAdvancedCustomAttributeComponent } from "./s25ql.search.advanced.custom.attribute.component";
import { S25QLSearchAdvancedHeadCountCriterionComponent } from "./s25ql.search.advanced.head.count.criterion.component";
import { S25QLSearchAdvancedProfileComponent } from "./s25ql.search.advanced.profile.component";
import { QLUtil } from "./s25ql.util";
import NumericalString = Proto.NumericalString;
import StepType = SearchCriteria.StepType;
import StepParam = SearchCriteria.StepParam;
import Ids = Item.Ids;

@Component({
    selector: "s25-ng-ql-search-advanced-criterion",
    template: `
        @if (isInit) {
            <s25-simple-collapse
                [header]="name"
                [hasClose]="true"
                (closed)="onClose()"
                [class.hasValidationError]="validationError"
            >
                <div class="criterion">
                    @if (+step.step_type_id % 100 === 45) {
                        <div class="flexRow">
                            <label for="advancedCriterion{{ id }}--keyword" class="ngBold">Keyword</label>
                            <input
                                id="advancedCriterion{{ id }}--keyword"
                                placeholder="Keyword"
                                class="c-input"
                                [maxLength]="48"
                                [(ngModel)]="stepParam.itemName"
                                (ngModelChange)="change.emit()"
                            />
                        </div>
                    } @else if (+step.step_type_id % 100 >= 50 && +step.step_type_id % 100 < 60) {
                        @if (stepParam.cust_atrb_id === -72 && +step.sub_step_type_id === 1) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">SIS Sync Paused</s25-ng-checkbox>
                        } @else {
                            <s25-ng-ql-search-advanced-custom-attribute
                                [type]="type"
                                [(modelValue)]="stepParam"
                                (modelValueChange)="onCustomAttributeChange()"
                            ></s25-ng-ql-search-advanced-custom-attribute>
                        }
                    } @else if (step.step_type_id === 20) {
                        @if (type === 1 && stepParam.related_event_type_id === 11) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Has Related Events</s25-ng-checkbox>
                        } @else if (type === 1 && stepParam.related_event_type_id === 12) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Has Bound Events</s25-ng-checkbox>
                        } @else if (type === 4) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locationRelatedTypes' }"
                            ></ng-container>
                        }
                    }
                    @switch (step.step_type_id) {
                        @case (Step.Event.Favorites) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Favorites</s25-ng-checkbox>
                        }
                        @case (Step.Event.Details) {
                            @if (showAll || stepParam.itemName !== undefined) {
                                <label for="advancedCriterion{{ id }}--name" class="ngBold">Event Name</label>
                                <ng-container [ngTemplateOutlet]="searchMethod"></ng-container>
                                <input
                                    id="advancedCriterion{{ id }}--name"
                                    placeholder="Name"
                                    class="c-input"
                                    [maxLength]="40"
                                    [(ngModel)]="stepParam.itemName"
                                    (ngModelChange)="change.emit()"
                                />
                            } @else if (showAll || stepParam.event_title !== undefined) {
                                <label for="advancedCriterion{{ id }}--title" class="ngBold">Event Title</label>
                                <input
                                    id="advancedCriterion{{ id }}--title"
                                    placeholder="Title"
                                    class="c-input"
                                    [maxLength]="248"
                                    [(ngModel)]="stepParam.event_title"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.reference_number !== undefined) {
                                <label for="advancedCriterion{{ id }}--reference" class="ngBold">Reference</label>
                                <input
                                    id="advancedCriterion{{ id }}--reference"
                                    placeholder="YYYY-ABCDEF"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.reference_number"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.event_structure_element_type !== undefined) {
                                <label for="advancedCriterion{{ id }}--structure" class="ngBold"
                                    >Structure Element</label
                                >
                                <select
                                    id="advancedCriterion{{ id }}--structure"
                                    class="cn-form__control"
                                    [(ngModel)]="stepParam.event_structure_element_type"
                                    (ngModelChange)="change.emit()"
                                >
                                    <option value="E">Event</option>
                                    <option value="F">Folder</option>
                                    <option value="C">Cabinet</option>
                                </select>
                                <span class="note">Note: Cabinets and Folders are not returned in 25Live</span>
                            }
                            @if (showAll || stepParam.start_dt !== undefined) {
                                <label for="advancedCriterion{{ id }}--startDate" class="ngBold"
                                    >Earliest Start Date</label
                                >
                                <s25-ng-editable-date
                                    id="advancedCriterion{{ id }}--startDate"
                                    [allowEmpty]="true"
                                    [alwaysEditing]="true"
                                    [val]="stepParam.start_dt"
                                    (valChange)="setStartDt($event)"
                                ></s25-ng-editable-date>
                            }
                            @if (showAll || stepParam.end_dt !== undefined) {
                                <label for="advancedCriterion{{ id }}--endDate" class="ngBold">Latest End Date</label>
                                <s25-ng-editable-date
                                    id="advancedCriterion{{ id }}--endDate"
                                    [allowEmpty]="true"
                                    [alwaysEditing]="true"
                                    [val]="stepParam.end_dt"
                                    (valChange)="setEndDt($event)"
                                ></s25-ng-editable-date>
                            }
                            @if (showAll || stepParam.modified_since !== undefined) {
                                <ng-container [ngTemplateOutlet]="modifiedSince"></ng-container>
                            }
                            @if (showAll || stepParam.last_modified_by !== undefined) {
                                <ng-container [ngTemplateOutlet]="modifiedBy"></ng-container>
                            }
                            @if (showAll || stepParam.alien_uid !== undefined) {
                                <label for="advancedCriterion{{ id }}--uid" class="ngBold">Alien UID</label>
                                <input
                                    id="advancedCriterion{{ id }}--uid"
                                    placeholder="UID"
                                    class="c-input"
                                    [maxLength]="100"
                                    [(ngModel)]="stepParam.alien_uid"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (!showAll) {
                                <button class="aw-button aw-button--outline" (click)="showAll = true">Show All</button>
                            }
                        }
                        @case (Step.Event.Events) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'events' }"
                            ></ng-container>
                        }
                        @case (Step.Event.EventSearch) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'event' }"></ng-container>
                        }
                        @case (Step.Event.EventSearchExclude) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'event' }"></ng-container>
                        }
                        @case (Step.Event.Folders) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'eventFolders' }"
                            ></ng-container>
                        }
                        @case (Step.Event.Cabinets) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'eventCabinets' }"
                            ></ng-container>
                        }
                        @case (Step.Event.CreatedDate) {
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--time" class="ngBold">Time</label>
                                <s25-timepicker
                                    id="advancedCriterion{{ id }}--time"
                                    [(modelValue)]="stepParam.start_time"
                                    (modelValueChange)="change.emit()"
                                ></s25-timepicker>
                            </div>
                            <ng-container [ngTemplateOutlet]="fromDate"></ng-container>
                        }
                        @case (Step.Event.Types) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { all: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'eventTypes' }"
                            ></ng-container>
                        }
                        @case (Step.Event.States) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'eventStates' }"
                            ></ng-container>
                        }
                        @case (Step.Event.Organizations) {
                            <ng-container *ngTemplateOutlet="qualifiers"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'organizations' }"
                            ></ng-container>
                        }
                        @case (Step.Event.SponsoringOrganizations) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'organization' }"></ng-container>
                        }
                        @case (Step.Event.Contacts) {
                            <select
                                class="cn-form__control"
                                [(ngModel)]="step.contact_role_id"
                                (ngModelChange)="change.emit()"
                            >
                                @for (role of contactRoles; track role.role_id) {
                                    <option [value]="role.role_id">
                                        {{ role.role_name }}
                                    </option>
                                }
                            </select>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'contacts' }"
                            ></ng-container>
                        }
                        @case (Step.Event.Categories) {
                            <ng-container *ngTemplateOutlet="qualifiers"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'eventCategories' }"
                            ></ng-container>
                        }
                        @case (Step.Event.Requirements) {
                            <ng-container *ngTemplateOutlet="qualifiers"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'eventRequirements' }"
                            ></ng-container>
                        }
                        @case (Step.Event.Occurrences) {
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--startTime" class="ngBold">Start Time:</label>
                                <s25-timepicker
                                    id="advancedCriterion{{ id }}--startTime"
                                    [(modelValue)]="stepParam.occurrence_start_dt"
                                    (modelValueChange)="change.emit()"
                                ></s25-timepicker>
                            </div>

                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--endTime" class="ngBold">End Time:</label>
                                <s25-timepicker
                                    id="advancedCriterion{{ id }}--endTime"
                                    [(modelValue)]="stepParam.occurrence_end_dt"
                                    (modelValueChange)="change.emit()"
                                ></s25-timepicker>
                            </div>

                            <ng-container [ngTemplateOutlet]="fromDate"></ng-container>
                            <ng-container [ngTemplateOutlet]="untilDate"></ng-container>

                            <div>
                                <label for="advancedCriterion{{ id }}--include" class="ngBold">Include</label>
                                <div id="advancedCriterion{{ id }}--include" class="flexRow">
                                    <s25-ng-checkbox [(value)]="stepParam.monday" (valueChange)="change.emit()" class=""
                                        >Monday</s25-ng-checkbox
                                    >
                                    <s25-ng-checkbox
                                        [(value)]="stepParam.tuesday"
                                        (valueChange)="change.emit()"
                                        class=""
                                        >Tuesday</s25-ng-checkbox
                                    >
                                    <s25-ng-checkbox
                                        [(value)]="stepParam.wednesday"
                                        (valueChange)="change.emit()"
                                        class=""
                                        >Wednesday</s25-ng-checkbox
                                    >
                                    <s25-ng-checkbox
                                        [(value)]="stepParam.thursday"
                                        (valueChange)="change.emit()"
                                        class=""
                                        >Thursday</s25-ng-checkbox
                                    >
                                    <s25-ng-checkbox [(value)]="stepParam.friday" (valueChange)="change.emit()" class=""
                                        >Friday</s25-ng-checkbox
                                    >
                                    <s25-ng-checkbox
                                        [(value)]="stepParam.saturday"
                                        (valueChange)="change.emit()"
                                        class=""
                                        >Saturday</s25-ng-checkbox
                                    >
                                    <s25-ng-checkbox [(value)]="stepParam.sunday" (valueChange)="change.emit()" class=""
                                        >Sunday</s25-ng-checkbox
                                    >
                                </div>
                            </div>
                        }
                        @case (Step.Event.ReservationDetails) {
                            @if (stepParam.reservation_name !== undefined) {
                                <div class="flexRow">
                                    <label for="advancedCriterion{{ id }}--segment" class="ngBold">Segment Name</label>
                                    <input
                                        id="advancedCriterion{{ id }}--segment"
                                        type="text"
                                        [(ngModel)]="stepParam.reservation_name"
                                        (ngModelChange)="change.emit()"
                                        class="c-input"
                                    />
                                </div>
                            }
                            @if (
                                stepParam.expected_head_count_gte !== undefined ||
                                stepParam.expected_head_count_lte !== undefined
                            ) {
                                <label class="ngBold">Expected Head Count</label>
                                <div class="flexRow">
                                    <label for="advancedCriterion{{ id }}--expectedMin">Minimum:</label>
                                    <input
                                        id="advancedCriterion{{ id }}--expectedMin"
                                        type="number"
                                        [(ngModel)]="stepParam.expected_head_count_gte"
                                        (ngModelChange)="change.emit()"
                                        class="c-input"
                                    />
                                </div>
                                <div class="flexRow">
                                    <label for="advancedCriterion{{ id }}--expectedMax">Maximum:</label>
                                    <input
                                        id="advancedCriterion{{ id }}--expectedMax"
                                        type="number"
                                        [(ngModel)]="stepParam.expected_head_count_lte"
                                        (ngModelChange)="change.emit()"
                                        class="c-input"
                                    />
                                </div>
                            }
                            @if (
                                stepParam.registered_head_count_gte !== undefined ||
                                stepParam.registered_head_count_lte !== undefined
                            ) {
                                <label class="ngBold">Registered Head Count</label>
                                <div class="flexRow">
                                    <label for="advancedCriterion{{ id }}--registeredMin">Minimum:</label>
                                    <input
                                        id="advancedCriterion{{ id }}--registeredMin"
                                        type="number"
                                        [(ngModel)]="stepParam.registered_head_count_gte"
                                        (ngModelChange)="change.emit()"
                                        class="c-input"
                                    />
                                </div>
                                <div class="flexRow">
                                    <label for="advancedCriterion{{ id }}--registeredMax">Maximum:</label>
                                    <input
                                        id="advancedCriterion{{ id }}--registeredMax"
                                        type="number"
                                        [(ngModel)]="stepParam.registered_head_count_lte"
                                        (ngModelChange)="change.emit()"
                                        class="c-input"
                                    />
                                </div>
                            }
                            @if (stepParam.head_count_left !== undefined) {
                                <s25-ng-ql-search-advanced-head-count-criterion
                                    [stepParam]="stepParam"
                                    (changed)="change.emit()"
                                />
                            }
                        }
                        @case (Step.Event.AssignedSpaces) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { none: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locations' }"
                            ></ng-container>
                        }
                        @case (Step.Event.SpaceAssignments) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'location' }"></ng-container>
                        }
                        @case (Step.Event.SpacePreferences) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { none: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locations' }"
                            ></ng-container>
                        }
                        @case (Step.Event.MissingSpaceAssignments) {
                            <ng-container [ngTemplateOutlet]="fromDate"></ng-container>
                            <ng-container [ngTemplateOutlet]="untilDate"></ng-container>
                        }
                        @case (Step.Event.AssignedResources) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { none: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'resources' }"
                            ></ng-container>
                        }
                        @case (Step.Event.ResourcesAssignments) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'resource' }"></ng-container>
                        }
                        @case (Step.Event.OutstandingNeedsSpaceVCalendarToDos) {
                            <s25-ng-checkbox [value]="true" [disabled]="true"
                                >Outstanding vCalendar "To Do": Needs Space</s25-ng-checkbox
                            >
                        }
                        @case (Step.Event.OutstandingExceedsHeadcountVCalendarToDos) {
                            <s25-ng-checkbox [value]="true" [disabled]="true"
                                >Outstanding vCalendar "To Do" Tasks: Exceeds Head Count</s25-ng-checkbox
                            >
                        }
                        @case (Step.Event.OutstandingExportVCalendarToDos) {
                            <s25-ng-checkbox [value]="true" [disabled]="true"
                                >Outstanding vCalendar "To Do" Tasks: Export</s25-ng-checkbox
                            >
                        }
                        @case (Step.Event.ProfileCode) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { all: false }"></ng-container>
                            <s25-ng-ql-search-advanced-profile
                                [(profileCodes)]="profileCodes"
                                (profileCodesChange)="onProfileCodesChange($event)"
                            >
                            </s25-ng-ql-search-advanced-profile>
                        }
                        @case (Step.Event.StandardSchedule) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { all: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'standardSchedules' }"
                            ></ng-container>
                            <s25-simple-collapse
                                [header]="'Meeting Patterns (' + meetingPatternsCount + ')'"
                                [expanded]="false"
                            >
                                <s25-ng-standard-schedule-patterns
                                    [options]="{ showScheduleName: true }"
                                    [items]="step.step_param"
                                    (patternsCount)="meetingPatternsCount = $event"
                                ></s25-ng-standard-schedule-patterns>
                            </s25-simple-collapse>
                        }
                        @case (Step.Event.Attendee) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'contacts' }"
                            ></ng-container>
                        }
                        @case (Step.Event.HasInvoices) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Has Invoices</s25-ng-checkbox>
                        }
                        @case (Step.Event.HasOutstandingBalance) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Has Outstanding Balance</s25-ng-checkbox>
                        }
                        @case (Step.Event.HasPayments) {
                            <ng-container *ngTemplateOutlet="paymentStatus"></ng-container>
                        }
                        @case (Step.Organization.HasInvoices) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Has Invoices</s25-ng-checkbox>
                        }
                        @case (Step.Organization.HasOutstandingBalance) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Has Outstanding Balance</s25-ng-checkbox>
                        }
                        @case (Step.Organization.HasPayments) {
                            <ng-container *ngTemplateOutlet="paymentStatus"></ng-container>
                        }
                        @case (Step.Event.HasFile) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Has File</s25-ng-checkbox>
                        }
                        @case (Step.Event.FileName) {
                            <label for="advancedCriterion{{ id }}--filename" class="ngBold">File Name</label>
                            <input
                                id="advancedCriterion{{ id }}--filename"
                                class="c-input"
                                [maxLength]="80"
                                [(ngModel)]="stepParam.file_name"
                                (ngModelChange)="change.emit()"
                            />
                        }
                        @case (Step.Location.Details) {
                            @if (showAll || stepParam.itemName !== undefined) {
                                <label for="advancedCriterion{{ id }}--name" class="ngBold">Location Name</label>
                                <ng-container [ngTemplateOutlet]="searchMethod"></ng-container>
                                <input
                                    id="advancedCriterion{{ id }}--name"
                                    placeholder="Name"
                                    class="c-input"
                                    [maxLength]="40"
                                    [(ngModel)]="stepParam.itemName"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.formal_name !== undefined) {
                                <label for="advancedCriterion{{ id }}--formal" class="ngBold">Formal Name</label>
                                <input
                                    id="advancedCriterion{{ id }}--formal"
                                    placeholder="Formal Name"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.formal_name"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.max_capacity !== undefined) {
                                <label for="advancedCriterion{{ id }}--maxCapacity" class="ngBold"
                                    >Maximum Capacity</label
                                >
                                <input
                                    id="advancedCriterion{{ id }}--maxCapacity"
                                    type="number"
                                    class="c-input"
                                    [(ngModel)]="stepParam.max_capacity"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.min_capacity !== undefined) {
                                <label for="advancedCriterion{{ id }}--minCapacity" class="ngBold"
                                    >Minimum Capacity</label
                                >
                                <input
                                    id="advancedCriterion{{ id }}--minCapacity"
                                    type="number"
                                    class="c-input"
                                    [(ngModel)]="stepParam.min_capacity"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.fill_ratio !== undefined) {
                                <label for="advancedCriterion{{ id }}--fillRatio" class="ngBold">Fill Ratio</label>
                                <input
                                    id="advancedCriterion{{ id }}--fillRatio"
                                    type="number"
                                    class="c-input"
                                    [(ngModel)]="stepParam.fill_ratio"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.modified_since !== undefined) {
                                <ng-container [ngTemplateOutlet]="modifiedSince"></ng-container>
                            }
                            @if (showAll || stepParam.last_modified_by !== undefined) {
                                <ng-container [ngTemplateOutlet]="modifiedBy"></ng-container>
                            }
                            @if (!showAll) {
                                <button class="aw-button aw-button--outline" (click)="showAll = true">Show All</button>
                            }
                        }
                        @case (Step.Location.Spaces) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locations' }"
                            ></ng-container>
                        }
                        @case (Step.Location.Search) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'location' }"></ng-container>
                        }
                        @case (Step.Location.Buildings) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { all: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'buildings' }"
                            ></ng-container>
                        }
                        @case (Step.Location.Partitions) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { all: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locationPartitions' }"
                            ></ng-container>
                        }
                        @case (Step.Location.Features) {
                            <ng-container *ngTemplateOutlet="qualifiers"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locationFeatures' }"
                            ></ng-container>
                        }
                        @case (Step.Location.Categories) {
                            <ng-container *ngTemplateOutlet="qualifiers"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locationCategories' }"
                            ></ng-container>
                        }
                        @case (Step.Location.Layouts) {
                            <ng-container *ngTemplateOutlet="qualifiers"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locationLayouts' }"
                            ></ng-container>
                        }
                        @case (Step.Location.SpaceRelationships) {
                            <ng-container *ngTemplateOutlet="qualifiers"></ng-container>
                            <div>
                                <label for="advancedCriterion{{ id }}--relationship" class="ngBold">Relationship</label>
                                <select
                                    id="advancedCriterion{{ id }}--relationship"
                                    [(ngModel)]="step.relationship_type_id"
                                    (ngModelChange)="updateRelationshipType($event)"
                                    class="cn-form__control"
                                >
                                    <option value="1">Subdivision Of</option>
                                    <option value="2">Close To</option>
                                    <option value="3">Blocked By</option>
                                    <option value="4">Also Assign</option>
                                    <option value="5">Divides Into</option>
                                </select>
                            </div>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'locations' }"
                            ></ng-container>
                        }
                        @case (Step.Location.AssignedSpaces) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'events' }"
                            ></ng-container>
                        }
                        @case (Step.Location.SpaceAssignments) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'event' }"></ng-container>
                        }
                        @case (Step.Organization.Details) {
                            @if (showAll || stepParam.itemName !== undefined) {
                                <div>
                                    <label for="advancedCriterion{{ id }}--name" class="ngBold"
                                        >Organization Name</label
                                    >
                                    <ng-container [ngTemplateOutlet]="searchMethod"></ng-container>
                                    <input
                                        id="advancedCriterion{{ id }}--name"
                                        placeholder="Name"
                                        class="c-input"
                                        [maxLength]="40"
                                        [(ngModel)]="stepParam.itemName"
                                        (ngModelChange)="change.emit()"
                                    />
                                </div>
                            }
                            @if (showAll || stepParam.formal_name !== undefined) {
                                <label for="advancedCriterion{{ id }}--title" class="ngBold">Organization Title</label>
                                <input
                                    id="advancedCriterion{{ id }}--title"
                                    placeholder="Formal Name"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.formal_name"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.s25_keys !== undefined) {
                                <s25-ng-checkbox [(value)]="stepParam.s25_keys" (valueChange)="change.emit()"
                                    >Schedule25 Key</s25-ng-checkbox
                                >
                            }
                            @if (showAll || stepParam.accounting_code !== undefined) {
                                <label for="advancedCriterion{{ id }}--accountCode" class="ngBold"
                                    >Accounting Code</label
                                >
                                <input
                                    id="advancedCriterion{{ id }}--accountCode"
                                    type="text"
                                    class="c-input"
                                    [maxLength]="100"
                                    [(ngModel)]="stepParam.accounting_code"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.modified_since !== undefined) {
                                <ng-container [ngTemplateOutlet]="modifiedSince"></ng-container>
                            }
                            @if (showAll || stepParam.last_modified_by !== undefined) {
                                <ng-container [ngTemplateOutlet]="modifiedBy"></ng-container>
                            }
                            @if (!showAll) {
                                <button class="aw-button aw-button--outline" (click)="showAll = true">Show All</button>
                            }
                        }
                        @case (Step.Organization.Organizations) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'organizations' }"
                            ></ng-container>
                        }
                        @case (Step.Organization.Search) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'organization' }"></ng-container>
                        }
                        @case (Step.Organization.Address) {
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--type">Address Type</label>
                                <select
                                    id="advancedCriterion{{ id }}--type"
                                    class="cn-form__control"
                                    [(ngModel)]="stepParam.address_type_id"
                                    (ngModelChange)="change.emit()"
                                >
                                    <option value="-1">(none)</option>
                                    <option value="1">Administration</option>
                                    <option value="2">Billing</option>
                                </select>
                            </div>
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--contains">Address Contains</label>
                                <input
                                    id="advancedCriterion{{ id }}--contains"
                                    type="text"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.address"
                                    (ngModelChange)="change.emit()"
                                />
                            </div>
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--city">City</label>
                                <input
                                    id="advancedCriterion{{ id }}--city"
                                    type="text"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.city"
                                    (ngModelChange)="change.emit()"
                                />
                            </div>
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--zip">Zip/Post</label>
                                <input
                                    id="advancedCriterion{{ id }}--zip"
                                    type="text"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.zip"
                                    (ngModelChange)="change.emit()"
                                />
                            </div>
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--country">Country</label>
                                <input
                                    id="advancedCriterion{{ id }}--country"
                                    type="text"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.country"
                                    (ngModelChange)="change.emit()"
                                />
                            </div>
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--phone">Phone</label>
                                <input
                                    id="advancedCriterion{{ id }}--phone"
                                    type="text"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.phone"
                                    (ngModelChange)="change.emit()"
                                />
                            </div>
                            <div class="flexRow">
                                <label for="advancedCriterion{{ id }}--fax">Fax</label>
                                <input
                                    id="advancedCriterion{{ id }}--fax"
                                    type="text"
                                    class="c-input"
                                    [maxLength]="78"
                                    [(ngModel)]="stepParam.fax"
                                    (ngModelChange)="change.emit()"
                                />
                            </div>
                        }
                        @case (Step.Organization.Categories) {
                            <ng-container *ngTemplateOutlet="qualifiers"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'organizationCategories' }"
                            ></ng-container>
                        }
                        @case (Step.Organization.Contacts) {
                            <select
                                class="cn-form__control"
                                [(ngModel)]="step.contact_role_id"
                                (ngModelChange)="change.emit()"
                            >
                                @for (role of contactRoles; track role.role_id) {
                                    <option value="{{ role.role_id }}">
                                        {{ role.role_name }}
                                    </option>
                                }
                            </select>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'contacts' }"
                            ></ng-container>
                        }
                        @case (Step.Organization.Types) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { all: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'organizationTypes' }"
                            ></ng-container>
                        }
                        @case (Step.Organization.Ratings) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: { all: false }"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'organizationRatings' }"
                            ></ng-container>
                        }
                        @case (Step.Organization.AssignedOrganizations) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'events' }"
                            ></ng-container>
                        }
                        @case (Step.Organization.OrganizationAssignments) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'event' }"></ng-container>
                        }
                        @case (Step.Resource.Details) {
                            @if (showAll || stepParam.itemName !== undefined) {
                                <div>
                                    <label for="advancedCriterion{{ id }}--name" class="ngBold">Resource Name</label>
                                    <ng-container [ngTemplateOutlet]="searchMethod"></ng-container>
                                    <input
                                        id="advancedCriterion{{ id }}--name"
                                        placeholder="Name"
                                        class="c-input"
                                        [maxLength]="40"
                                        [(ngModel)]="stepParam.itemName"
                                        (ngModelChange)="change.emit()"
                                    />
                                </div>
                            }
                            @if (showAll || stepParam.modified_since !== undefined) {
                                <div>
                                    <ng-container [ngTemplateOutlet]="modifiedSince"></ng-container>
                                </div>
                            }
                            @if (showAll || stepParam.last_modified_by !== undefined) {
                                <div>
                                    <ng-container [ngTemplateOutlet]="modifiedBy"></ng-container>
                                </div>
                            }
                            @if (!showAll) {
                                <button class="aw-button aw-button--outline" (click)="showAll = true">Show All</button>
                            }
                        }
                        @case (Step.Resource.Resources) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'resources' }"
                            ></ng-container>
                        }
                        @case (Step.Resource.Search) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'resource' }"></ng-container>
                        }
                        @case (Step.Resource.Categories) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: {}"></ng-container>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'resourceCategories' }"
                            ></ng-container>
                        }
                        @case (Step.Resource.Relationships) {
                            <ng-container *ngTemplateOutlet="qualifiers; context: {}"></ng-container>
                            <select
                                class="cn-form__control"
                                [ngModel]="step.relationship_type_id"
                                (ngModelChange)="updateRelationshipType($event)"
                            >
                                <option value="8">Substitute With</option>
                                <option value="9">Also Assign</option>
                            </select>
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'resources' }"
                            ></ng-container>
                        }
                        @case (Step.Resource.AssignedResources) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'events' }"
                            ></ng-container>
                        }
                        @case (Step.Resource.ResourceAssignments) {
                            <ng-container *ngTemplateOutlet="search; context: { type: 'event' }"></ng-container>
                        }
                        @case (Step.Contact.Favorites) {
                            <s25-ng-checkbox [value]="true" [disabled]="true">Favorites</s25-ng-checkbox>
                        }
                        @case (Step.Contact.Details) {
                            @if (showAll || stepParam.first_name !== undefined) {
                                <label for="advancedCriterion{{ id }}--firstName" class="ngBold">First Name</label>
                                <input
                                    id="advancedCriterion{{ id }}--firstName"
                                    placeholder="First Name"
                                    class="c-input"
                                    [maxLength]="80"
                                    [(ngModel)]="stepParam.first_name"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.last_name !== undefined) {
                                <label for="advancedCriterion{{ id }}--lastName" class="ngBold">Last Name</label>
                                <input
                                    id="advancedCriterion{{ id }}--lastName"
                                    placeholder="Last Name"
                                    class="c-input"
                                    [maxLength]="80"
                                    [(ngModel)]="stepParam.last_name"
                                    (ngModelChange)="change.emit()"
                                />
                            }
                            @if (showAll || stepParam.internal_id !== undefined) {
                                <label for="advancedCriterion{{ id }}--internalId" class="ngBold">Internal ID</label>
                                <input
                                    id="advancedCriterion{{ id }}--internalId"
                                    placeholder="Internal ID"
                                    class="c-input"
                                    [maxLength]="80"
                                    [(ngModel)]="stepParam.internal_id"
                                    (ngModelChange)="change.emit()"
                                />
                            }

                            @if (!showAll) {
                                <button class="aw-button aw-button--outline" (click)="showAll = true">Show All</button>
                            }
                        }
                        @case (Step.Contact.Email) {
                            <label for="advancedCriterion{{ id }}--email" class="ngBold">Email</label>
                            <input
                                id="advancedCriterion{{ id }}--email"
                                placeholder="Email"
                                class="c-input"
                                [maxLength]="100"
                                type="email"
                                [(ngModel)]="stepParam.email"
                                (ngModelChange)="change.emit()"
                            />
                        }
                        @case (Step.Contact.ModifiedSince) {
                            <ng-container [ngTemplateOutlet]="modifiedSince"></ng-container>
                        }
                        @case (Step.Contact.Contacts) {
                            <ng-container
                                *ngTemplateOutlet="searchCriteria; context: { type: 'contacts' }"
                            ></ng-container>
                        }
                        @case (Step.Contact.SecurityGroup) {
                            <ng-container
                                *ngTemplateOutlet="
                                    searchCriteria;
                                    context: { type: 'securityGroups', singleSelect: true }
                                "
                            ></ng-container>
                        }
                    }
                </div>

                @if (validationError) {
                    <p class="validationError">
                        {{ validationError }}
                    </p>
                }
            </s25-simple-collapse>
        }

        <ng-template #searchMethod>
            <select
                aria-label="operator"
                class="cn-form__control"
                [(ngModel)]="stepParam.searchMethod"
                (ngModelChange)="change.emit()"
            >
                <option value="is">is</option>
                <option value="starts with">Starts With</option>
                <option value="contains">Contains</option>
                <option value="ends with">Ends With</option>
            </select>
        </ng-template>

        <ng-template #modifiedSince>
            <label for="advancedCriterion{{ id }}--modifiedSince" class="ngBold">Modified Since</label>
            <s25-ng-editable-date-time
                [allowEmpty]="true"
                [alwaysEditing]="true"
                [(val)]="stepParam.modified_since"
                (valChange)="change.emit()"
                [dateInputId]="'advancedCriterion' + id + '--modifiedSince'"
            ></s25-ng-editable-date-time>
        </ng-template>

        <ng-template #modifiedBy>
            <label for="advancedCriterion{{ id }}--lastModifiedBy" class="ngBold">Last Modified By</label>
            <input
                id="advancedCriterion{{ id }}--lastModifiedBy"
                type="text"
                [maxLength]="40"
                [(ngModel)]="stepParam.last_modified_by"
                (ngModelChange)="change.emit()"
                class="c-input"
            />
            <span class="note">(Enter contact username)</span>
        </ng-template>

        <ng-template #fromDate>
            <div class="">
                <label for="advancedCriterion{{ id }}--from" class="ngBold">From</label>
                <div id="advancedCriterion{{ id }}--from">
                    <div class="flexRow">
                        <s25-ng-radio
                            [(value)]="stepParam.from_dt_type"
                            (valueChange)="onFromDtTypeChange()"
                            [name]="'fromDate' + id"
                            [radioValue]="'number'"
                            [style.display]="'block'"
                        >
                            Today +/-
                        </s25-ng-radio>
                        @if (stepParam.from_dt_type === "number") {
                            <input
                                [(ngModel)]="stepParam.from_dt_num"
                                (ngModelChange)="setFromDt($event)"
                                type="number"
                                class="c-input"
                            />
                        }
                    </div>
                    <div class="flexRow">
                        <s25-ng-radio
                            [(value)]="stepParam.from_dt_type"
                            (valueChange)="onFromDtTypeChange()"
                            [name]="'fromDate' + id"
                            [radioValue]="'date'"
                        >
                            Specific Date
                        </s25-ng-radio>
                        @if (stepParam.from_dt_type === "date") {
                            <s25-ng-editable-date
                                [(val)]="stepParam.from_dt_date"
                                (valChange)="setFromDt($event)"
                            ></s25-ng-editable-date>
                        }
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #untilDate>
            <div>
                <label for="advancedCriterion{{ id }}--until" class="ngBold">Until</label>
                <div id="advancedCriterion{{ id }}--until" class="flexRow">
                    <s25-ng-radio
                        [(value)]="stepParam.until_dt_type"
                        (valueChange)="onUntilDtTypeChange()"
                        [name]="'untilDate' + id"
                        [radioValue]="'number'"
                        [style.display]="'block'"
                        >Day(s) Following</s25-ng-radio
                    >
                    @if (stepParam.until_dt_type === "number") {
                        <input
                            [(ngModel)]="stepParam.until_dt_num"
                            (ngModelChange)="setUntilDt($event)"
                            type="number"
                            class="c-input"
                        />
                    }
                </div>
                <div class="flexRow">
                    <s25-ng-radio
                        [(value)]="stepParam.until_dt_type"
                        [name]="'untilDate' + id"
                        [radioValue]="'date'"
                        (valueChange)="onUntilDtTypeChange()"
                    >
                        Specific Date
                    </s25-ng-radio>
                    @if (stepParam.until_dt_type === "date") {
                        <s25-ng-editable-date
                            [(val)]="stepParam.until_dt_date"
                            (valChange)="setUntil($event)"
                        ></s25-ng-editable-date>
                    }
                </div>
            </div>
        </ng-template>

        <ng-template #qualifiers let-any="any" let-all="all" let-none="none">
            <select
                [(ngModel)]="step.qualifier"
                (ngModelChange)="change.emit()"
                class="cn-form__control"
                aria-label="search style"
            >
                @if (any !== false) {
                    <option [value]="1">Include Any</option>
                }
                @if (all !== false) {
                    <option [value]="2">Include All</option>
                }
                @if (none !== false) {
                    <option [value]="-1">Do Not Include</option>
                }
            </select>
        </ng-template>

        <ng-template #searchCriteria let-type="type" let-singleSelect="singleSelect">
            <s25-ng-multiselect-search-criteria
                [type]="type"
                [modelBean]="{ showResult: true, singleSelect: singleSelect || false }"
                [selectedItems]="step.step_param"
                [popoverPlacement]="'right'"
                [useSecurity]="true"
                (changed)="setObjectsData($event)"
            ></s25-ng-multiselect-search-criteria>
        </ng-template>

        <ng-template #search let-type="type">
            <div class="flexRow">
                <label for="advancedCriterion{{ id }}--search--{{ type }}">Search</label>
                @if (stepParam?.isPrivate) {
                    <div class="privateSearch">
                        Private
                        <s25-ng-info-message>You do not have permission to view this search</s25-ng-info-message>
                    </div>
                } @else if (!stepParam?.isPrivate) {
                    <s25-ng-search-dropdown
                        id="advancedCriterion{{ id }}--search--{{ type }}"
                        [type]="type"
                        [allowNonQueryId]="false"
                        [value]="stepParam"
                        (valueChange)="setObjectsData([$event])"
                    />
                }
            </div>
        </ng-template>

        <ng-template #paymentStatus>
            <label for="advancedCriterion{{ id }}--paymentStatus" class="ngBold">Payment Status</label>
            <select
                id="advancedCriterion{{ id }}--paymentStatus"
                class="cn-form__control"
                [ngModel]="stepParam.payment_status ?? ''"
                (ngModelChange)="onPaymentStatusChange($event)"
            >
                <option value="">Any Status</option>
                <option value="paid">Paid</option>
                <option value="unpaid">Unpaid</option>
            </select>
        </ng-template>
    `,
    styles: `
        .criterion {
            display: flex;
            flex-direction: column;
            gap: 1em;
            padding: 1em;
        }

        label,
        select,
        input,
        s25-contact-dropdown,
        s25-ng-editable-date-time,
        ::ng-deep s25-ng-ql-search-advanced-criterion s25-datepicker input {
            width: 14em;
            display: block;
            margin-bottom: 0.5em;
        }

        .flexRow {
            display: flex;
            gap: 1em;
            flex-wrap: wrap;
        }

        .flexRow > * {
            width: fit-content;
            margin: auto 0;
        }

        .flexRow > label {
            min-width: 6em;
        }

        s25-ng-search-dropdown {
            min-width: 17em;
        }

        s25-ng-radio {
            min-width: 10em;
        }

        s25-ng-multiselect-search-criteria .s25-multiselect-popup-container {
            --multiselect--preferred-width: 50vw;
        }

        .validationError {
            padding: 1em;
            color: #c00;
            font-size: 0.9em;
        }

        ::ng-deep s25-ng-ql-search-advanced-criterion .hasValidationError s25-simple-collapse {
            border: 1px solid #c00 !important;
        }

        ::ng-deep .nm-party--on s25-ng-ql-search-advanced-criterion .validationError {
            color: #ff8b8b;
        }

        ::ng-deep .nm-party--on s25-ng-ql-search-advanced-criterion .hasValidationError s25-simple-collapse {
            border: 1px solid #ff8b8b !important;
        }

        ::ng-deep .nm-party--on s25-ng-ql-search-advanced-criterion .privateSearch {
            color: #fff;
        }

        .note {
            color: #707070;
        }

        ::ng-deep .nm-party--on s25-ng-ql-search-advanced-criterion .note {
            color: #aaa;
        }

        ::ng-deep s25-ng-standard-schedule-patterns s25-ng-table {
            margin-top: 1em;
            margin-left: 0.625rem;
        }
    `,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        S25SimpleCollapseModule,
        S25qlSearchAdvancedCustomAttributeComponent,
        S25CheckboxModule,
        NgTemplateOutlet,
        FormsModule,
        S25EditableModule,
        S25TimepickerModule,
        S25QLSearchAdvancedProfileComponent,
        S25StandardScheduleModule,
        S25RadioModule,
        S25MultiselectModule,
        S25DropdownPaginatedModule,
        S25InfoMessageModule,
        S25QLSearchAdvancedHeadCountCriterionComponent,
    ],
})
export class S25qlSearchAdvancedCriterionComponent implements OnInit {
    public static count = 0;

    @Input() type: Item.Id;
    @Input() step: AdvancedStep;
    @Input() allSteps: AdvancedStep[] = []; // All steps from parent model for duplicate checking

    @Output() closed = new EventEmitter<void>();
    readonly change = output<void>();

    id: number;
    isInit = false;
    Step = StepType;
    S25QLConst = S25QLConst;
    contactRoles: { role_id: string; role_name: string }[] = [];
    name: string;
    showAll = false;
    validationError: string | null;
    profileCodes: string[];
    meetingPatternsCount: number;

    toStartOfDay = S25Util.date.toStartOfDay;
    toEndOfDay = S25Util.date.toEndOfDay;

    // defaultStepParam is necessary so that the reference doesn't change each on each get
    defaultStepParam = {};
    get stepParam() {
        return this.step.step_param?.length ? this.step.step_param[0] : this.defaultStepParam;
    }
    set stepParam(param: StepParam) {
        this.step.step_param[0] = param;
        this.change.emit();
    }

    constructor() {
        this.id = S25qlSearchAdvancedCriterionComponent.count;
        S25qlSearchAdvancedCriterionComponent.count++;
    }

    async ngOnInit() {
        const stepTypeId = S25QLConst.stepNormMap[this.step.step_type_id] || Number(this.step.step_type_id);
        // Sets step_type_id to custom attribute
        this.step.step_type_id = stepTypeId;
        this.name = this.getName(this.step);
        if (stepTypeId === StepType.Event.Contacts || stepTypeId === StepType.Organization.Contacts) {
            this.contactRoles = await SearchCriteriaService.getRolesFiltered(this.type);
            this.contactRoles.unshift({ role_id: "0", role_name: "Any Role" });
            this.step.contact_role_id ??= "0";
        }

        if (stepTypeId === StepType.Event.Occurrences) {
            for (const day of Proto.DowNameLowercase) this.stepParam[day] = this.stepParam[day] === "T";
        }
        if (this.stepParam?.from_dt !== undefined) {
            this.stepParam.from_dt_type =
                isNaN(this.stepParam.from_dt) || S25Util.date.isDate(this.stepParam.from_dt) ? "date" : "number";
            this.stepParam.from_dt_date =
                this.stepParam.from_dt_type === "date" ? this.stepParam.from_dt : S25Util.date.toStartOfDay(new Date());
            this.stepParam.from_dt_num = this.stepParam.from_dt_type === "date" ? 0 : this.stepParam.from_dt;
        }
        if (this.stepParam?.until_dt !== undefined) {
            this.stepParam.until_dt_type =
                isNaN(this.stepParam.until_dt) || S25Util.date.isDate(this.stepParam.until_dt) ? "date" : "number";
            this.stepParam.until_dt_date =
                this.stepParam.until_dt_type === "date" ? this.stepParam.until_dt : S25Util.date.toEndOfDay(new Date());
            this.stepParam.until_dt_num = this.stepParam.until_dt_type === "date" ? 1 : this.stepParam.until_dt;
        }
        if (stepTypeId === StepType.Location.SpaceRelationships || stepTypeId === StepType.Resource.Relationships) {
            this.step.step_param = this.step.step_param.filter((item) => item.itemName);
            if (!this.step.step_param.length)
                this.updateRelationshipType(stepTypeId === StepType.Location.SpaceRelationships ? 1 : 8); // Select first by default
        }
        if (this.stepParam?.relationship_type_id !== undefined) {
            this.updateRelationshipType(Number(this.stepParam.relationship_type_id) || 1);
        }
        if (this.stepParam?.contact_role_id !== undefined)
            this.step.contact_role_id = Number(this.stepParam.contact_role_id) || "0";
        if (stepTypeId === StepType.Event.HasPayments || stepTypeId === StepType.Organization.HasPayments) {
            this.stepParam.has_payments = 1;
        }
        if (this.stepParam?.profile_code !== undefined) {
            this.profileCodes = this.step.step_param.map((p) => p.profile_code || "hh:mm|hh:mm|W1 MO TU WE TH FR");
            this.onProfileCodesChange(this.profileCodes);
        }

        this.step.qualifier ??= 1;

        // Set "show all" when the right number of parameters are present
        const paramValues = Object.keys(this.stepParam ?? {}).length;
        const showAllValues: any = {
            [StepType.Event.Details]: 10,
            [StepType.Location.Details]: 8,
            [StepType.Organization.Details]: 7,
            [StepType.Resource.Details]: 6,
            [StepType.Contact.Details]: 4,
        };
        if (showAllValues[stepTypeId] === paramValues) this.showAll = true;

        this.isInit = true;
    }

    getName(step: AdvancedStep): string {
        let stepType = Number(step.step_type_id);
        if (stepType % 100 >= 50 && stepType % 100 < 60) stepType = this.type * 100 + 50;

        if (
            step.step_param?.length &&
            this.type === Item.Ids.Event &&
            stepType === StepType.Event.IncludeRelatedEvents
        ) {
            const stepParam = step.step_param[0];
            if (stepParam.related_event_type_id === 11) return "Has Related Events";
            if (stepParam.related_event_type_id === 12) return "Has Bound Events";
        }

        if (step.step_param?.length && this.type === Item.Ids.Event && step.step_param[0]?.cust_atrb_id === -72) {
            return "SIS Sync Paused";
        }

        return S25QLConst.advancedUIOptionName[this.type][stepType];
    }

    onClose() {
        this.closed.emit();
    }

    onPaymentStatusChange(paymentStatus: string) {
        if (paymentStatus) {
            this.stepParam.payment_status = paymentStatus;
        } else {
            delete this.stepParam.payment_status;
        }
        this.stepParam.has_payments = 1;
        this.change.emit();
    }

    setObjectsData(data: any[]) {
        const relationship_type_id = this.step.relationship_type_id || 1;
        const relationshipIsItemId = this.type === Ids.Location && this.step.step_type_id === 20;
        this.step.step_param = data.map(({ itemName, itemId, txt, val }) => ({
            itemName,
            itemId: String(itemId),
            relationship_type_id: relationshipIsItemId ? itemId : relationship_type_id,
            txt,
            val,
        }));
        this.change.emit();
    }

    updateRelationshipType(type: number | NumericalString) {
        this.step.relationship_type_id = type;
        for (const param of this.step.step_param) param.relationship_type_id = type;
        this.change.emit();
    }

    onCustomAttributeChange() {
        if (!this.stepParam.relationship_type_id) return;
        this.step.step_type_id = this.stepParam.relationship_type_id % 1000;
        this.change.emit();
    }

    // For contacts, check for duplicate parameters
    checkForDuplicateParameters() {
        if (this.type === Item.Ids.Contact) {
            const currentStepTypeId = Number(this.step.step_type_id);
            const normalizedCurrentStepTypeId = QLUtil.normalizeStepTypeId(currentStepTypeId, this.type);

            // All custom attributes are treated as the same parameter type
            if (normalizedCurrentStepTypeId === this.type * 100 + 50) {
                const duplicateStep = this.allSteps.find((otherStep) => {
                    if (otherStep === this.step) return false; // Don't compare with self
                    const otherStepTypeId = Number(otherStep.step_type_id);
                    return QLUtil.isCustomAttributeStepType(otherStepTypeId);
                });

                if (duplicateStep) {
                    this.validationError = "For contacts, you can only use one custom attribute at a time.";
                    return;
                }
            } else {
                // Other parameters are identified by step_type_id
                const duplicateStep = this.allSteps.find((otherStep) => {
                    if (otherStep === this.step) return false; // Don't compare with self
                    const otherStepTypeId = Number(otherStep.step_type_id);
                    const normalizedOtherStepTypeId = QLUtil.normalizeStepTypeId(otherStepTypeId, this.type);
                    return normalizedOtherStepTypeId === normalizedCurrentStepTypeId;
                });

                if (duplicateStep) {
                    this.validationError = "For contacts, you can only use one parameter of each type.";
                    return;
                }
            }

            // Clear validation error if no duplicate found
            this.validationError = null;
        }
    }

    onProfileCodesChange(params: string[]) {
        this.step.step_param = params.map((p) => {
            return { profile_code: p || "" };
        });
        this.change.emit();
    }
    validate(): boolean {
        let id = Number(this.step.step_type_id);
        if (id % 100 >= 50 && id % 100 < 60) id = this.type * 100 + 50; // If custom attribute, set stepTypeId to X50
        const itemTypeData = AdvancedSearchUtil.s25SearchAdvancedStepTemplate[S25Const.itemId2Name[this.type]];
        const validator = itemTypeData.validation?.[id];
        this.validationError = validator?.(this.step) || null;

        // For contacts, check for duplicate parameters
        if (this.type === Item.Ids.Contact && !this.validationError) {
            this.checkForDuplicateParameters();
        }

        return !this.validationError; // No error message = OK
    }

    protected setStartDt(value: any) {
        this.stepParam.start_dt = value && S25Util.date.toStartOfDay(value);
        this.change.emit();
    }

    protected setEndDt(value: any) {
        this.stepParam.end_dt = value && S25Util.date.toEndOfDay(value);
        this.change.emit();
    }

    protected onFromDtTypeChange() {
        this.stepParam.from_dt =
            this.stepParam.from_dt_type === "number" ? this.stepParam.from_dt_num : this.stepParam.from_dt_date;
        this.change.emit();
    }

    protected setFromDt(value: any) {
        this.stepParam.from_dt = value;
        this.change.emit();
    }

    protected onUntilDtTypeChange() {
        this.stepParam.until_dt =
            this.stepParam.until_dt_type === "number" ? this.stepParam.until_dt_num : this.stepParam.until_dt_date;
        this.change.emit();
    }

    protected setUntilDt(value: any) {
        this.stepParam.until_dt = value;
        this.change.emit();
    }

    protected setUntil($event: any) {
        this.stepParam.until_dt = S25Util.date.toEndOfDay($event);
        this.change.emit();
    }
}
